const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.94737,0,0,2.94737,-54.5263,-47.1579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black-Logo-Square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_-",
    d: "M28.223,20.385C29.055,20.385 30.098,19.805 30.719,19.032C31.281,18.331 31.691,17.353 31.691,16.374C31.691,16.242 31.68,16.109 31.656,16C30.73,16.036 29.617,16.64 28.949,17.449C28.422,18.065 27.941,19.032 27.941,20.022C27.941,20.167 27.965,20.312 27.977,20.36C28.035,20.373 28.129,20.385 28.223,20.385ZM25.293,35C26.43,35 26.934,34.215 28.352,34.215C29.793,34.215 30.109,34.976 31.375,34.976C32.617,34.976 33.449,33.792 34.234,32.633C35.113,31.304 35.477,29.999 35.5,29.939C35.418,29.915 33.039,28.912 33.039,26.098C33.039,23.658 34.914,22.559 35.02,22.474C33.777,20.638 31.891,20.59 31.375,20.59C29.98,20.59 28.844,21.46 28.129,21.46C27.355,21.46 26.336,20.638 25.129,20.638C22.832,20.638 20.5,22.595 20.5,26.291C20.5,28.586 21.367,31.014 22.434,32.584C23.348,33.913 24.145,35 25.293,35Z",
    style: {
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIconBlack);
export default __webpack_public_path__ + "static/media/apple-icon-black.b9897d299f65c62ae4faff7cf0f795d5.svg";
export { ForwardRef as ReactComponent };